import { Route } from '@angular/router';
import { SbShareOfVoiceComponent } from '../../../../../pages/statistics/sb-share-of-voice/sb-share-of-voice.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const publisherShareOfVoice: Route = {
  path: 'publisher-share-of-voice',
  component: SbShareOfVoiceComponent,
  title: 'nav.reporting.publisher.shareOfVoice',
  data: {
    breadcrumb: 'nav.reporting.publisher.shareOfVoice',
    icon: SbIcons.pieChartStake,
    id: RoutingID.publisherShareOfVoice,
  },
};
